/** @format */

import React, { useEffect, useState } from "react";
import { BiExport, BiImport } from "react-icons/bi";
import { toast } from "react-toastify";
import Select from "react-select";
import Loader from "../../../Components/Loader";
import { vendorService } from "../../../Services/vendorService";
import TntService from "../../../Services/TntService";
import TntConsolService from "../../../Services/TntConsolService";
import locationServices from "../../../Services/locationServices";

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

const serviceOption = [
  { value: "EXPORT", label: "EXPORT" },
  { value: "IMPORT", label: "IMPORT" },
];

export const LandExpress = () => {
  const [loader, setLoader] = useState(true);
  const [errprovider, SetErrprovider] = useState();
  const [errservice, SetErrservice] = useState();
  const [countryList, setCountryList] = useState([]);

  const [serviceType, setServiceType] = useState({
    value: "",
    label: "",
  });

  //   const [courierOptionlist, setCourierOptionlist] = useState();
  const [courierList, setCourierList] = useState();
  const [countryValue, setCountryValue] = useState("");

  useEffect(() => {
    getItemList();
  }, []);

  //   const getVendorList = () => {
  //     vendorService.getVendor().then((res) => {
  //       if (res.status === true) {
  //         let arryVendor = [];
  //         res.data.map((val) => {
  //           if (val.vendor_type === "Courier")
  //             arryVendor.push({ value: val._id, label: val.vendor_name });
  //         });
  //         setCourierOptionlist(arryVendor);
  //       }
  //     });
  //   };

  useEffect(() => {
    const initialService = serviceOption.filter(
      (res) => res.value === "EXPORT"
    )[0];
    setServiceType({
      value: initialService.value,
      label: initialService.label,
    });
  }, []);

  useEffect(() => {
    getCountryList();
  }, [countryValue.value]);

  const getCountryList = () => {
    let param = {
      limit: 250,
      page: 1,
    };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        // arry.push({ value: '', label: 'All country' })
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name });
        });
        const initialValue = res.data.filter(
          (res) => res.country_iso2 === "AE"
        )[0];
        setCountryValue({
          value: initialValue._id,
          label: initialValue.country_name,
        });
        setCountryList(arry);
      }
    });
  };

  const onSelectCountry = (e) => {
    setCountryValue(e);
    getItemList(serviceType.label, e.value);
  };

  const onSelecttype = (e) => {
    setServiceType(e);
    getItemList(e.label, countryValue.value);
  };

  const getItemList = (type, countryid) => {
     let param = {
      service_type: type ? type.toUpperCase() : "EXPORT",
    //   origin_country: countryid ? countryid : "611f41670f747d25b17c04e7",
     };
    setLoader(false);
    // TntService.getTntfreight(param).then((res) => {
      TntConsolService.get_tnt_land_cons_freight(param).then((res) => {
      if (res.status) {
        setLoader(false);
        let data = res.data.sort((a,b)=> a.cbm-b.cbm)
        setCourierList(data);
      } else {
        setLoader(false);
      }
    });
  };

  const onClickExport = () => {
    setLoader(true);
    var errorcount = 0;

    if (serviceType.value === undefined) {
      SetErrservice("*required.");
      errorcount++;
    }

    if (!courierList) {
      toast.error("No data found !");
      errorcount++;
    }

    let param = {
      service_type: serviceType.value ? serviceType.value : "EXPORT",
      origin_country: countryValue && countryValue.value,
    };

    if (errorcount === 0) {
      // TntService.exportTntfreightData(param).then((res) => {
        TntConsolService.export_tnt_land_cons_freight(param).then((res) => {
        if (res.status) {
          window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
          toast.success("file download successfully");
          setLoader(false);
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  const onClickImport = (e) => {
    var Errcount = 0;

    if (serviceType.value === undefined) {
      SetErrservice("*required.");
      Errcount++;
    }

    const formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    formData.append("service_type", serviceType.value);
    formData.append("origin_country", countryValue.value);

    if (Errcount === 0) {
      // TntService.importTntfreightData(formData).then((res) => {
        TntConsolService.import_tnt_land_cons_freight(formData).then((res) => {
        if (res.status) {
          getItemList();
          toast.success("file upload successfully");
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex justify-content-between mb-3">
                {/* <div className="me-3">
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with service..."
                    value={providerType}
                    onChange={(e) => onSelectprovider(e)}
                    options={courierOptionlist}
                  />
                  {!providerType.value && (
                    <div className="text-danger">{errprovider}</div>
                  )}
                </div> */}
                <div className="me-3">
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with type..."
                    value={serviceType}
                    onChange={(e) => onSelecttype(e)}
                    options={serviceOption}
                  />
                  {!serviceType.value && (
                    <div className="text-danger">{errservice}</div>
                  )}
                </div>

                {/* <div className="me-3">
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with country..."
                    value={countryValue}
                    onChange={(e) => onSelectCountry(e)}
                    options={countryList}
                  />
                </div> */}
              </div>
              <div className="d-flex justify-content-end mb-3">
                <div>
                  <input
                    type="file"
                    id="upload"
                    accept=".csv"
                    hidden
                    onChange={(e) => onClickImport(e)}
                  />
                  <label
                    for="upload"
                    className="btn btn-danger waves-effect waves-light mx-1 my-0"
                  >
                    <BiExport />
                    Upload File
                  </label>
                </div>
                <div>
                  <button
                    className="btn btn-success waves-effect waves-light mx-1 my-0"
                    onClick={() => onClickExport()}
                  >
                    <BiImport />
                    Download File
                  </button>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              {courierList && courierList.length > 0 && (
                <table className="table table-centered table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="p-1 small">CBM</th>
                      {courierList &&
                        courierList[0].destination_price.map((val) => {
                          return (
                            <th>
                              {val.country}{" "}
                              <small className="text-muted">({val.city})</small>{" "}
                            </th>
                          );
                        })}
                    </tr>
                  </thead>
                  <tbody>
                    {courierList &&
                      courierList.map((item, key) => {
                        return (
                          <tr>
                            <th className="p-1 small">{item.cbm}</th>
                            {item &&
                              item.destination_price.map((val) => {
                                return <th>{val.price}</th>;
                              })}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              )}

              {courierList && courierList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> No data available</h6>
                </div>
              )}
            </div>
          </div>
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
